<template>
  <div class="main-container">
    <tl-header type="h1">
      <div>LOP / RLOP</div>
      <template slot="icon" v-if="!showIntro">
        <div class="row-container">
          <div class="showIntro" v-on:click="goToIntro">
            <img class="imgClass" src="@/assets/questionmark.png" />
          </div>
        </div>
      </template>
    </tl-header>
    <div>
      <div class="row-container center">
        <div class="company-info" v-show="showIntro">
          <img class="image" src="@/assets/team.svg" />
          <div v-on:click="hideIntro">
            <img class="closeImage" src="@/assets/close.png" />
          </div>
          <div class="fontStyle">
            <span>Loss of pay and Reversal of loss of pay for previous months can be added here. These will be considered in current month’s payroll.</span>
          </div>
        </div>
      </div>
      <div>
        <lops-and-rlops @lopsLocking="lockingLops" />
      </div>
      <div class="line"></div>
      <br />
      <br />
      <btn-grp class="btnGrp">
        <btn text="Cancel" type="secondary" @click="cancel" />
        <btn text="Next" :disabled="!isLopsLocked" type="primary" @click="next" />
      </btn-grp>
    </div>
  </div>
</template>

<script>
import LopsAndRlops from "./lopsandrlops.vue";
export default {
  name: "lopsandrlopsIntro",
  components: { LopsAndRlops },
  data() {
    return {
      showIntro: true,
      isLopsLocked: false
    };
  },
  methods: {
    /** to hide the intro screen if paygroups available */
    hideIntro() {
      this.showIntro = false;
    },
    /** to show the intro screen if paygroups are not available */
    goToIntro() {
      this.showIntro = true;
    },
    lockingLops(event) {
      this.isLopsLocked = event;
    },
    /** Navigation */
    cancel() {
        this.$router.push({
        path: `/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
        }/selectedEmployee`
      });
    },
    /** Navigation */
    next() {
        this.$router.push({
        path: `/payroll/run/${
          this.$route.params.entity_index ? this.$route.params.entity_index : 0
        }/variableEarningsForOffPayroll`
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/scss/components/introPage.scss";
.line {
  border-bottom: 1px solid #34c0be;
  flex-grow: 1;
  margin-top: 15%;
}
.btnGrp {
  float: right;
}
</style>
